import React from "react";
import { useRental } from "../../../contexts/api";
import type { RentalProduct } from "../../../api/rental/Rental.typed";

export default function useRentalCatalogue() {
  const { listRentalProducts } = useRental();
  const [products, setProducts] = React.useState<RentalProduct[]>([]);
  const [loading, setLoading] = React.useState(false);

  const refresh = React.useCallback(async () => {
    setLoading(true);
    const res = await listRentalProducts();
    setProducts(res ?? []);
    setLoading(false);
  }, [listRentalProducts]);

  React.useEffect(() => {
    refresh();
  }, [refresh]);

  return { products, loading, refresh };
}
